import type { EquipmentRow } from '../../lib/types';
import { mediaUrl } from '../../lib/storage';
import { reorder } from '../../lib/reorder';
import { Chip, ChipRow } from '../../components/Chip';
import { Button } from '../../components/Button';

type Props = {
  allEquipment: EquipmentRow[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
};

/** Multi-select from the equipment library, with photos, orderable by sort. Never an upload here (spec §3 Lane D). */
export function EquipmentPicker({ allEquipment, selectedIds, onChange }: Props) {
  const byId = new Map(allEquipment.map((e) => [e.id, e]));
  const available = allEquipment.filter((e) => !e.archived_at && !selectedIds.includes(e.id));

  function add(id: string) {
    onChange([...selectedIds, id]);
  }
  function remove(id: string) {
    onChange(selectedIds.filter((x) => x !== id));
  }
  function move(index: number, dir: -1 | 1) {
    onChange(reorder(selectedIds, index, index + dir));
  }

  return (
    <div>
      {selectedIds.length === 0 ? <p className="muted">No equipment picked -- equipment will save as "none"/"bodyweight".</p> : null}
      <div className="row" style={{ flexWrap: 'wrap', marginBottom: 12 }}>
        {selectedIds.map((id, index) => {
          const eq = byId.get(id);
          if (!eq) return null;
          const url = mediaUrl(eq.photo_path);
          return (
            <div key={id} className="row-card" style={{ flex: 'initial', display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
              {url ? <img className="thumb" src={url} alt="" /> : <div className="thumb" />}
              <span>{eq.name_en}</span>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <button type="button" className="sort-handle" disabled={index === 0} onClick={() => move(index, -1)}>
                  ↑
                </button>
                <button type="button" className="sort-handle" disabled={index === selectedIds.length - 1} onClick={() => move(index, 1)}>
                  ↓
                </button>
              </div>
              <Button tone="danger" size="sm" onClick={() => remove(id)}>
                Remove
              </Button>
            </div>
          );
        })}
      </div>
      <p className="muted" style={{ marginBottom: 8 }}>
        Add from the library (first item sets the exercise's equipment class):
      </p>
      <ChipRow>
        {available.map((e) => (
          <Chip key={e.id} onClick={() => add(e.id)}>
            {e.name_en}
          </Chip>
        ))}
      </ChipRow>
    </div>
  );
}
